function setAddMany(set, items) {
  let allowFalsy = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  for (const item of items) {
    if (allowFalsy || !!item) {
      set.add(item);
    }
  }
  return set;
}
function setToString(set) {
  let separator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ' ';
  return Array.from(set).filter(Boolean).join(separator);
}
export { setAddMany, setToString };